import { AutocompleteOption, useAutocomplete } from '@/common/presentation/hooks/useAutocomplete';

import { useGetAccountTypesAutocompleteQuery } from '@/common/infrastructure/gql/generated/schema';

type AccountType = NonNullable<
  NonNullable<NonNullable<ReturnType<typeof useGetAccountTypesAutocompleteQuery>['data']>['accountTypes']>['items']
>[number];

export const useListAccountTypesAutocomplete = (
  searchTerm: string = '',
  debounceMs: number = 1000,
  onAccountTypeSelect?: (accountType: AutocompleteOption) => void,
  skip: boolean = false
) => {
  // Call the GraphQL hook at the top level (following Rules of Hooks)
  const result = useGetAccountTypesAutocompleteQuery({
    variables: { skip: 0, search: searchTerm },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    skip
  });

  return useAutocomplete<AccountType>({
    searchTerm,
    debounceMs,
    onSelect: onAccountTypeSelect,
    query: () => {
      return {
        data: { items: result.data?.accountTypes?.items },
        loading: result.loading,
        error: result.error
      };
    },
    transform: (accountType) => ({
      value: accountType.id ?? 0,
      label: accountType.accountType ?? 'Unknown Account Type'
    })
  });
};
